export const RESET_STATE = 'RESET_STATE';
export const REHYDRATE = 'REHYDRATE';
export const resetState = () => ({
    type: RESET_STATE,
  });

export const rehydrate = () => ({
    type: REHYDRATE,
})